import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';
import './services/localization/Localization';
import './styles/index.css';
import 'react-multi-carousel/lib/styles.css';
import 'react-mobile-style-picker/dist/index.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as Sentry from '@sentry/react';

declare global {
  interface Window {
    Cypress: any;
    store: any;
    gtag: any;
  }
}

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
    normalizeDepth: 10,
    environment: import.meta.env.MODE,
    attachStacktrace: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

if (window.Cypress) {
  window.store = store;
}

reportWebVitals();
